/** Скелетоны вместо спиннера: экран не «мигает», а показывает будущую форму. */

export function SkeletonLine({ width = '100%' }: { width?: string }): JSX.Element {
  return <span className="skeleton skeleton--line" style={{ width }} />;
}

export function SummarySkeleton(): JSX.Element {
  return (
    <div className="summary summary--skeleton" aria-hidden="true">
      <div className="summary__cell">
        <SkeletonLine width="72px" />
        <SkeletonLine width="46px" />
      </div>
      <div className="summary__cell">
        <SkeletonLine width="64px" />
        <SkeletonLine width="40px" />
      </div>
      <div className="summary__cell">
        <SkeletonLine width="80px" />
        <SkeletonLine width="52px" />
      </div>
    </div>
  );
}

export function StopListSkeleton({ count = 4 }: { count?: number }): JSX.Element {
  return (
    <ul className="stops" aria-busy="true" aria-label="Маршрут загружается">
      {Array.from({ length: count }, (_, index) => (
        <li className="stop stop--skeleton" key={index} aria-hidden="true">
          <div className="stop__badge skeleton" />
          <div className="stop__main">
            <SkeletonLine width="65%" />
            <SkeletonLine width="42%" />
            <SkeletonLine width="80%" />
          </div>
        </li>
      ))}
    </ul>
  );
}
